/**
 * @file Allow using app feature flags
 */
import { hasWwDebugUrlParam } from '@@/bits/dev_url_params'
import environment from '@@/bits/environment'
import window from '@@/bits/global'

type CurrentFlags =
  | 'accessControlSettingsV2'
  | 'accessControlSettingsV2RetroactiveUpdate'
  | 'actionMenu2026'
  | 'addPostLink'
  | 'affiliateSignupLink'
  | 'aiImageSearch'
  | 'aiMakeFromPrompt'
  | 'aiPermissionsForAiRecipes'
  | 'aiPermissionsForImageAndSpeechGeneration'
  | 'aiSuggestionsOnMakePage'
  | 'allSlideAsImageWithBanksy'
  | 'arLensesPreview'
  | 'attachmentPreviewWidthAdjustmentForGridFormat'
  | 'banksy'
  | 'banksyDev'
  | 'billingAddress'
  | 'bulkEmailChangeForLibraries'
  | 'brahmsCheck'
  | 'campus'
  | 'changeEmailVerification'
  | 'checkoutDeclineModal'
  | 'classesV1'
  | 'classInformation'
  | 'classMemberListPaste'
  | 'classroomLicensesV2'
  | 'classroomPlanPricingExperiment'
  | 'commentAutoPublishOnUpload'
  | 'crossPlatformAttachmentSettings'
  | 'currentSlideAsImageWithBanksy'
  | 'customEmojiReactions'
  | 'customPostUserProperty'
  | 'customPostVoteAndRatingProperties'
  | 'dailyEmailDigestTeacher'
  | 'v2EmailDigestTreatment'
  | 'dashboardAnnouncement'
  | 'dashboardWallRemake'
  | 'dashHeaderCtaButton'
  | 'dashRecentsGroupByLibrary'
  | 'debugFrontend'
  | 'defaultDashboardLibraryNavigation'
  | 'demoPadletPanel'
  | 'demoPadletSignup'
  | 'deprecateArsPlans'
  | 'deprecateDrivePage'
  | 'deprecateGoldPlans'
  | 'deviceIdLocalStorageReseed'
  | 'deviceUploads'
  | 'displayLocalPartRules'
  | 'downloadWallAttachmentsV2'
  | 'editThumbnail'
  | 'editThumbnailForAudioVideoFiles'
  | 'embeddedPadletsOnExpandedPost'
  | 'embedLogin'
  | 'exitTicket'
  | 'expandedViewForTextPosts'
  | 'fasterDashSettings'
  | 'featuredSection'
  | 'fetchLinksWithWishes'
  | 'frontChat'
  | 'fullClientSurface'
  | 'googleClassroom'
  | 'googleClassroomGrading'
  | 'googleWorkspaceRostering'
  | 'grading'
  | 'groupPostsV2'
  | 'higherMonthlyPricingPlans'
  | 'hideApprovedDomainsForNewSchools'
  | 'inboundEmailVerification'
  | 'internalNavigateImmediately'
  | 'invoiceNameOnCheckout'
  | 'joinCodes'
  | 'joypixels8p0'
  | 'landsideWorkerNavigation'
  | 'latamSpanishLanguage'
  | 'learnPageSessionsForAllTeachers'
  | 'learnWistiaVideos'
  | 'libraryAnalyticsActivateCtaExperiment'
  | 'libraryGoogleAppLicensing'
  | 'libraryLegacyPlanSwitch'
  | 'libraryLoginOtpToggle'
  | 'librarySamlLogin'
  | 'librarySettingsConnectionsTab'
  | 'librarySsoVerificationToggle'
  | 'lmsUserGroupSync'
  | 'loadWishesViaSortBy'
  | 'lottieWebWorker'
  | 'ltiCourseDuplication'
  | 'ltiDeepLinkingMenuV3'
  | 'magicPadlet'
  | 'makePageSimplifiedLayoutExperiment'
  | 'maoriLanguage'
  | 'mapRestrictRegion'
  | 'membersSelectV2'
  | 'microsoftOneDrivePicker'
  | 'microsoftTeams'
  | 'mobileDeviceDprOverride'
  | 'multiSelectCustomProperty'
  | 'nativeArCamera'
  | 'notifyFailedPayments'
  | 'nuxtTeamLibraryAnalytics'
  | 'posthogNpsSurvey'
  | 'posthogNpsSurveyAlwaysShow'
  | 'onboardingDemoV2'
  | 'onboardingDemoV2Copy'
  | 'onboardingGridLayout'
  | 'openInAppBanner'
  | 'openInAppOnAccessGate'
  | 'openInMobileApp'
  | 'ozVirtualListVirtua'
  | 'padletLive'
  | 'pdndSurfaceGrid'
  | 'pdndSurfaceMap'
  | 'pdndSurfaceMatrix'
  | 'personalPricingPlansExperiment'
  | 'personalPricingPlansExperimentV2'
  | 'piChatV2'
  | 'piInputV2'
  | 'pinsightInSurface'
  | 'piSandboxChat'
  | 'piSubmissionFormWidget'
  | 'piUndo'
  | 'platinumPostPurchaseNextSteps'
  | 'platinumResellerSelfServe'
  | 'playVideoInExpanded'
  | 'postComposerAttachmentPickerV2'
  | 'postVisibility'
  | 'posthogSessionRecording'
  | 'pptxImport'
  | 'prefetchSurface'
  | 'pwaInstallButton'
  | 'reactionsToCustomPropertiesMigration'
  | 'recycleOffscreenPosts'
  | 'remakeLink'
  | 'showRemakeLinkQr'
  | 'removeArchive'
  | 'renameAdminOwnerToCreator'
  | 'requirePaymentMethodToUndoCancellation'
  | 'routeToEurope'
  | 'rowsSectionScrubber'
  | 'samlIdp'
  | 'whiteboardPermissionsV2'
  | 'sandboxCardScroll'
  | 'sandboxGeoShapeBorderSettings'
  | 'sandboxNotePlaceholders'
  | 'sandboxMultiShapeColorUpdate'
  | 'sandboxMultiShapeShapeUpdate'
  | 'sandboxPerCardAllowedTools'
  | 'sandboxRadialMenu'
  | 'sandboxSimplifiedRoles'
  | 'schoolLibraryBillingAddress'
  | 'schoolLibraryFreeze'
  | 'schoolLibraryPaymentMethodUpdate'
  | 'schoolLibraryPermissions'
  | 'schoolLibrarySSO'
  | 'schoolSelectionForTeachers'
  | 'scrollSmoothnessTracking'
  | 'selfServeFreeTrial'
  | 'selfServePaymentMethodRemoval'
  | 'shareShortcuts'
  | 'showAnonymousUserNames'
  | 'showCommandPalette'
  | 'showInvitedLibraryUsers'
  | 'sidePanelsV2'
  | 'signUpSurface'
  | 'slideshowRemote'
  | 'slideshowSwipeNavigation'
  | 'structuredClassInformation'
  | 'suggestedTemplates'
  | 'surfaceAiChat'
  | 'surfaceAiChatSchools'
  | 'surfaceAiChatSchoolsPermission'
  | 'surfaceCommentsPerPost'
  | 'surfaceCommentVideoPlayer'
  | 'surfaceConnectionsChange'
  | 'surfaceContributorsModalV2'
  | 'surfacePostVideoPlayer'
  | 'surfaceLibraryOrgVisitorPermissions'
  | 'surfaceMapsV2'
  | 'surfaceRoleBadges'
  | 'surfaceShiftTextSelection'
  | 'surfaceTranslateFeedback'
  | 'swipeNavigationOnBoardExpandedView'
  | 'tableColumnHeaderSorting'
  | 'tamilLanguage'
  | 'threeDAttachment'
  | 'transferPadletTool'
  | 'transferPostWithCustomProperties'
  | 'transferSchoolPadletPermission'
  | 'translatePadlet'
  | 'translatePadletV2'
  | 'translationFeedback'
  | 'translationReporter'
  | 'turnstileOnSignup'
  | 'unicodeFontLoading'
  | 'unlimitedSandboxesEventOverQuotaBanner'
  | 'unlimitedSandboxesV2'
  | 'upgradeModalCopyAExperiment'
  | 'upgradeModalSingleStepExperiment'
  | 'useGoogleViewerForMicrosoftFiles'
  | 'viewAsPreview'
  | 'virtualFieldTrip'
  | 'virtualFieldTripNarration'
  | 'virtualizedColumns'
  | 'virtualizedDashboard'
  | 'virtualizedPostsGrid'
  | 'virtualizedSurfaceLists'
  | 'wallCardMaxWidth'
  | 'wallContentProtection'
  | 'wallEngagementTime'
  | 'wallEngagementTimeTracking'
  | 'yodishLanguage'
  | 'zapierIntegration'
  | 'nativeAccountSwitcher'
  | 'captionsTranslation'
  | 'arcadeAttachment'
  | 'arcadeGameInsightsEmailTeacher'

// Flips that hold a list of names instead of on or off.
type ListFlags = 'officeViewerDownApps'

function currentFlip() {
  const ww = window.ww || {}
  const viteAppFlip =
    window.wwStartingState != null && typeof window.wwStartingState === 'function' ? window.wwStartingState().flip : {}
  return ww.flip || ww.vueStartingState?.flip || viteAppFlip || {}
}

function isAppUsing(feature: CurrentFlags, version?: null | number): boolean {
  const flip = currentFlip()
  if (version) {
    return flip[feature] >= version
  }
  return flip[feature] || false
}

function appFlipList(feature: ListFlags): string[] {
  const value = currentFlip()[feature]
  return Array.isArray(value) ? value : []
}

const isDebugMode =
  (environment === 'test' && ['true', 'yes', '1'].includes(process.env.WW_DEBUG ?? '')) ||
  isAppUsing('debugFrontend') ||
  hasWwDebugUrlParam()

if (environment !== 'production' && isAppUsing('debugFrontend')) {
  console.log('Already debugging frontend in dev.') // goodcheck-disable-line
}

// If on padlet.dev, use the local Banksy server to test PDF exports.
// Banksy and Banksy Dev on Cloud Run won't work because they cannot access a padlet.dev padlet.
// You will need to run the Banksy server first before you can test PDF exports.
// See: /services/banksy/README.md
const isAppUsingBanksyLocalDev = environment === 'development'

export { appFlipList, isAppUsing, isAppUsingBanksyLocalDev, isDebugMode }
export type { CurrentFlags, ListFlags }
